import { DASHBOARD_TO_ADD_TO_PARAM } from '@modules/analysis/constants';
import { decompressURLSearchParams } from '@modules/common/utils';
import { populatePayloadFromSearchParams } from '@modules/common/utils/populatePayloadFromSearchParams';
import { QuantifyState } from '../store/types';

export const areInputsPresentInSearchParams = () => {
  const dashboardToAddToParam = new URLSearchParams(window.location.search).get(
    DASHBOARD_TO_ADD_TO_PARAM,
  );

  if (dashboardToAddToParam) {
    return true;
  }

  const metadataPayload: Partial<QuantifyState['metadata']> = {};
  populatePayloadFromSearchParams(
    metadataPayload,
    [
      'visibleDataPoints',
      'aggregatePeriod',
      'shouldShowTopDataPoints',
      'shouldShowAllValues',
      'topDataPointsSelectionCount',
      'anomalyThreshold',
      'sortBy',
      'shouldShowCooccurringDataPoints',
      'shouldShowAnomalies',
      'anomalyThreshold',
      'shouldShowCategories',
      'compareQBField',
      'compareDurationField',
      'activeVisualisationType',
    ],
    decompressURLSearchParams,
  );

  if (Object.keys(metadataPayload).length > 0) {
    return true;
  }

  const queryPayload: Partial<QuantifyState['query']> = {};
  populatePayloadFromSearchParams(
    queryPayload,
    [
      'groupBy',
      'duration',
      'whereClauseConfig',
      'shouldShowNormalisedValues',
      'compareTo',
      'formulaID',
      'denominatorWhereClause',
    ],
    decompressURLSearchParams,
  );

  if (Object.keys(queryPayload).length > 0) {
    return true;
  }

  return false;
};
